//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileUploader from '../../../views/common-components/file-uploader';
import SelectProjectModal from '../components/select-project-modal';

export default {
    name: 'saleProjectList',
    components: {
        SelectProjectModal,
        fileUploader
    },
    data() {
        var vm = this;
        return {
            loading: false,
            searchInput: {},
            list: [],
            totalCount: 0,
            pageSize: 10,
            currentPage: 1,
            saving: false,
            columns: [
                {
                    type: 'index', width: 60, align: 'center'
                },
                {
                    title: '名称', key: 'name', align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];
                        actions.push(h('a', {
                            on: {
                                click() {
                                    vm.showLouShuDetail(row);
                                }
                            }
                        }, row.name));
                        return h('div', actions);
                    }
                },
                {
                    title: '项目名称',
                    key: 'projectName',
                    align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];
                        actions.push(h('a', {
                            on: {
                                click() {
                                    vm.showProjectDetail(row);
                                }
                            }
                        }, row.projectName));
                        return h('div', actions);
                    }
                },
                {
                    title: '项目单价（元/㎡）',
                    key: 'danjia',
                    align: 'center'
                }
                // {
                //     title: '操作',
                //     render: (h, params) => {
                //         const row = params.row;
                //         const actions = [];
                //
                //         var del = h('Button', {
                //             props: {
                //                 type: 'error',
                //                 size: 'small'
                //             },
                //             style: {
                //                 marginRight: '5px'
                //             },
                //             on: {
                //                 click: () => {
                //                     vm.delCity(params.row);
                //                 }
                //             }
                //         }, '删除');
                //
                //         actions.push(h('Button', {
                //             props: {
                //                 type: 'primary',
                //                 size: 'small'
                //             },
                //             style: {
                //                 marginRight: '5px'
                //             },
                //             on: {
                //                 click: () => {
                //                     vm.editCity(params.row);
                //                 }
                //             }
                //         }, '编辑'));
                //         actions.push(del);
                //         return h('div', actions);
                //     }
                // }
            ],
            showEditLouShuModal: false,
            louShu: {
                file: { associateType: 'LouShuFile' }
            },
            louShuRules: {
                projectName: { required: true, message: '请选择项目', trigger: 'blur' },
                name: { required: true, message: '请输入名称', trigger: 'blur' }
            },
            showAddProjectModal: false
        };
    },
    methods: {
        pageChange(page) {
            // this.$store.commit('city/setCurrentPage', page);
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(pagesize) {
            // this.$store.commit('city/setPageSize', pagesize);
            this.pageSize = pagesize;
            this.getPage();
        },
        getPage() {
            this.loading = true;
            var page = {
                name: this.searchInput.name,
                maxResultCount: this.pageSize,
                skipCount: (this.currentPage - 1) * this.pageSize
            };
            this.searchInput.maxResultCount = this.pageSize;
            this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
            abp.ajax.post('/api/services/app/LouShu/SearchLouShu', this.searchInput).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });
        },
        editLouShu(l) {
            this.louShu = {};
            this.louShu = l;
            this.louShu.file = { associateType: 'LouShuFile' };
            this.showEditLouShuModal = true;
        },
        showLouShuDetail(row) {
            this.$router.push({
                name: 'onSaleDetail',
                params: {
                    id: row.id
                }
            });
        },
        showProjectDetail(row) {
            this.$router.push({
                name: 'projectDetail',
                params: {
                    id: row.projectId
                }
            });
        },
        onSaveLouShu() {
            var vm = this;
            this.$refs.loushuForm.validate(async (val) => {
                if (val) {
                    this.saving = true;
                    abp.ajax.post('/api/services/app/LouShu/SaveLouShu', vm.louShu).then(res => {
                        vm.$Notice.success({
                            duration: 3,
                            title: '保存成功'
                        });
                        this.showEditLouShuModal = false;
                        var row = {
                            id: res.data.result
                        };
                        this.showLouShuDetail(row);
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        showAddProject() {
            this.showAddProjectModal = true;
        },
        addProject(data) {
            // console.log(data);
            const vm = this;
            if (data) {
                vm.louShu.projectId = data.id;
                vm.louShu.projectName = data.name;
                vm.louShu.address = data.address;
                vm.showAddProjectModal = false;
            }
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    created() {
        this.getPage();
    }
};
